
export default {
	name: "NYTGamesCard",
	props: {
		to: { type: String, required: true },
		bgColor: { type: String, default: "white" },
		textColor: { type: String, default: "black" },
		title: { type: String, required: true },
		subtitle: { type: String, required: true },
		smallerTitle: { type: Boolean, default: false },
	},
	data() {
		return {
			isHovered: false,
			isActive: false,
		};
	},
	computed: {
		arrowIconDefault() {
			return require("~/assets/icons/bt-round.svg");
		},
		arrowIconHover() {
			return require("~/assets/icons/bt-round-hover.svg");
		},
		arrowIconActive() {
			return require("~/assets/icons/bt-round-active.svg");
		},
		arrowIconSrc() {
			if (this.isActive) {
				return this.arrowIconActive;
			}

			if (this.isHovered) {
				return this.arrowIconHover;
			}

			return this.arrowIconDefault;
		},
	},
};
